import { render, staticRenderFns } from "./SceneMaterialImageEntry_adding.vue?vue&type=template&id=028c1648&scoped=true&"
import script from "./SceneMaterialImageEntry_adding.vue?vue&type=script&lang=js&"
export * from "./SceneMaterialImageEntry_adding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c1648",
  null
  
)

export default component.exports